import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { TBulkIngredientPayload } from "../../sdk/utils/api/ingredients";

export const useBulkImportIngredients = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<{ created: number; updated: number; skipped: string[] }, unknown, { items: TBulkIngredientPayload[] }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<{ created: number; updated: number; skipped: string[] }, unknown, { items: TBulkIngredientPayload[] }>({
        mutationFn: async (parameters: { items: TBulkIngredientPayload[] }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.bulkImport(parameters.items, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
